import { isValidPhoneNumber as isValidPhoneNumberLib } from "react-phone-number-input"

export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  if (!phoneNumber) {
    return true
  }

  try {
    return isValidPhoneNumberLib(phoneNumber) || false
  } catch {
    return /^\+[1-9]\d{1,14}$/.test(phoneNumber)
  }
}

export const isSipAddress = (value: string): boolean => {
  return value.startsWith("sip:")
}

export const isValidSipAddress = (sipAddress: string): boolean => {
  if (!sipAddress) {
    return true
  }
  return /^sip:[^@\s]+@[^@\s]+\.[^@\s]+$/.test(sipAddress)
}
